import { useState } from 'react';
import { subscriptionService } from '@/services/subscription.service';
import { notificationService } from '@/services/notification.service';
import { cookieService } from '@/services/cookie.service';
import { StoredCookies } from '@/interfaces/auth/cookies.enum';

interface SubscriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubscribed: () => void;
  price: number;
}

export const SubscriptionModal = ({ isOpen, onClose, onSubscribed, price }: SubscriptionModalProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubscribe = async () => {
    try {
      setIsLoading(true);
      const username = cookieService.getCookie(StoredCookies.USERNAME) || '';
      const { subscriptionUrl } = await subscriptionService.createSubscription(username);
      window.location.href = subscriptionUrl;
      onSubscribed();
    } catch (error) {
      if (error instanceof Error) {
        notificationService.error(error.message);
      } else {
        notificationService.error('Error creating subscription');
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-testid="subscription-modal">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
        <h2 className="text-2xl font-bold mb-4" data-testid="subscription-modal-title">Subscription Required</h2>
        <p className="text-gray-600 mb-6" data-testid="subscription-modal-description">
          To access this feature, you need an active subscription.
        </p>
        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
            data-testid="subscription-modal-cancel"
          >
            Cancel
          </button>
          <button
            onClick={handleSubscribe}
            disabled={isLoading}
            className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-indigo-400"
            data-testid="subscription-modal-subscribe"
          >
            {isLoading ? 'Processing...' : 'Subscribe'}
          </button>
        </div>
      </div>
    </div>
  );
}; 